import styled from 'styled-components';

export const OverflowSpan = styled.span`
  display: block;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

// The cell is nowrap, so the tooltip is the only place typed line breaks show.
export const TooltipText = styled.span`
  display: block;
  white-space: pre-wrap;
`;
